import React from 'react'; 
import PropTypes from 'prop-types';
// import * as consts from '../../../constants';
import SectionHeader from '../../Basic/SectionHeader';
import TextBox from '../../Basic/TextBox';
import Select from '../../Basic/Select';
//import Address from '../Address';
import Address2 from '../Address2';

class ServiceAddressSelector extends React.Component {
  render() {
    const p = this.props;
    const items = [];
    const addressList = p.addressList;
    const lookup = p.lookup && p.lookup.serviceAddress;
    const customAddress = <Address2 name="siteAddress" title=" " />;
    if (addressList) {
      addressList.map((x) => {
        items.push({ id: x.id, name: x.formattedAddress });
      });
    }
    if (items.length <= 0)
      return null;
    return (
      <div>
        {addressList ?
          <div>
            <SectionHeader title={lookup && lookup.serviceAddress} />
            {items[0].id != -1 ?
              <div className="row">
                <div className="col-md-6">
                  <Select name="addressList" title={lookup && lookup.streetAddress} items={items} isControl required />
                </div>
                <div className="col-md-2">
                  <TextBox title="Unit number" id="unitNumber" name="unitNumber" disabled={p.isNoneSelected} maxLength={10} />
                </div>
              </div>
              :
              null
            }
            {p.isNoneSelected || items[0].id == -1 ? customAddress : null}
          </div> : null}
      </div>
    );
  }
}

ServiceAddressSelector.propTypes = {
  isNoneSelected: PropTypes.bool,
  addressList: PropTypes.array,
  productName: PropTypes.string
};

export default ServiceAddressSelector;